<template>
    <div v-if="showMode" class="minimizeClass">
        <div class="headerClass">
            <span>{{ componentObj.name }}</span>
            <div>
                <span @click="rebackShow()"><a-icon type="arrows-alt" title="还原" style="color: aliceblue;cursor: pointer;margin-right: 15px;" /></span>
                <span @click="close()"><a-icon type="close"  title="关闭" style="color: aliceblue;cursor: pointer;" /></span>
            </div>
        </div>
    </div>
</template>
  
  <script>
  export default {
    name: 'selectLayer',
    data() {
      return {
        showMode: false,
        componentObj:{}
      }
    },
    methods: {
        // 关闭
      close() {
        this.showMode = false
      },
    //恢复原始弹框
    rebackShow(){
        this.close()
        this.$emit('reback',this.componentObj)
    },
        // 初始化弹框信息
      setMap(msg) {
        this.componentObj = msg
        this.showMode = true
      },
        // 取消
        cancel(){
            this.close()
        },
    },
  }
  </script>
  
  <style lang="less" scoped>
  .minimizeClass {
    position: absolute;
    bottom: 30px;
    right: 50px;
    width: 350px;
    max-width: 350px;
    border-radius: 4px;
    color: #ffffff;
    backdrop-filter: blur(10px);
    .headerClass{
        width: 100%;
        height: 30px;
        opacity: 0.8;
        line-height: 30px;
        padding-left: 10px;
        padding-right: 10px;
        display: flex;
        justify-content: space-between;
    }
  }
  
  .minimizeClass input,
  .minimizeClass select,
  .minimizeClass textarea {
    color: #ffffff;
    border: 1px solid #e4eaec;
    font-size: 14px;
  }
  </style>
  